(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    if (!window.pbAccordionReady) {
  window.pbAccordionReady = true;

  function updateFaqSchema() {
    var accordions = document.querySelectorAll('.pb-acc[data-faq-schema="true"]');
    var schemaElement = document.getElementById('pb-accordion-faq-schema');
    var entities = [];
    var seen = new Set();

    accordions.forEach(function(accordion) {
      accordion.querySelectorAll('.pb-acc-item').forEach(function(item) {
        var title = item.querySelector('.pb-acc-title');
        var content = item.querySelector('.pb-acc-content');
        var question = title ? title.textContent.trim() : '';
        var answer = content ? content.innerHTML.trim() : '';
        var key = question + '\n' + answer;

        if (!question || !answer || seen.has(key)) return;
        seen.add(key);
        entities.push({
          '@type': 'Question',
          name: question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: answer
          }
        });
      });
    });

    if (!entities.length) {
      if (schemaElement) schemaElement.remove();
      return;
    }

    if (!schemaElement) {
      schemaElement = document.createElement('script');
      schemaElement.id = 'pb-accordion-faq-schema';
      schemaElement.type = 'application/ld+json';
      document.head.appendChild(schemaElement);
    }

    schemaElement.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: entities
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateFaqSchema, { once: true });
  } else {
    updateFaqSchema();
  }
  document.addEventListener('shopify:section:load', updateFaqSchema);
  document.addEventListener('shopify:block:select', updateFaqSchema);

  document.addEventListener('click', function(event) {
    var summary = event.target.closest('.pb-acc-summary');
    if (!summary) return;
    var item = summary.closest('.pb-acc-item');
    if (!item) return;
    var content = item.querySelector('.pb-acc-content');
    if (!content) return;

    event.preventDefault();
    var isOpen = item.hasAttribute('open');
    var startHeight = summary.offsetHeight + (isOpen ? content.offsetHeight : 0);

    if (!isOpen) item.setAttribute('open', '');
    var endHeight = summary.offsetHeight + (isOpen ? 0 : content.scrollHeight);

    item.classList.add('pb-acc-item--animating');
    item.style.height = startHeight + 'px';
    item.offsetHeight;
    item.style.transition = 'height .24s ease';
    item.style.height = endHeight + 'px';

    window.setTimeout(function() {
      item.style.transition = '';
      item.style.height = '';
      item.classList.remove('pb-acc-item--animating');
      if (isOpen) item.removeAttribute('open');
    }, 260);

    if (isOpen) return;
    var group = item.closest('.pb-acc[data-accordion-mode="single"]');
    if (!group) return;
    group.querySelectorAll('.pb-acc-item[open]').forEach(function(other) {
      if (other !== item) other.removeAttribute('open');
    });
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["content-tabs"] && !Shopify.designMode) return;
  try {
    (function() {
  function owned(root, selector) {
    return Array.prototype.filter.call(root.querySelectorAll(selector), function(element) {
      return element.closest('[data-pb-content-tabs]') === root;
    });
  }
  function buildButton(root, panel, index) {
    var button = document.createElement('button');
    var tabId = panel.id ? panel.id.replace('panel', 'button') : 'pb-tab-button-' + Math.random().toString(36).slice(2);
    if (!panel.id) panel.id = tabId.replace('button', 'panel');
    button.className = 'pb-tabs__button';
    button.type = 'button';
    button.setAttribute('role', 'tab');
    button.setAttribute('aria-controls', panel.id);
    button.setAttribute('aria-selected', 'false');
    button.tabIndex = -1;
    button.id = tabId;
    button.dataset.tabIndex = String(index);
    panel.setAttribute('aria-labelledby', tabId);

    var iconName = (panel.dataset.tabIcon || '').trim();
    if (iconName) {
      var icon = document.createElement('span');
      icon.className = 'pb-tabs__icon material-symbols-outlined';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = iconName;
      button.appendChild(icon);
    }

    var text = document.createElement('span');
    text.className = 'pb-tabs__button-text';

    var label = document.createElement('span');
    label.className = 'pb-tabs__button-label';
    label.textContent = panel.dataset.tabLabel || ('Tab ' + index);
    text.appendChild(label);

    var descriptionText = (panel.dataset.tabDescription || '').trim();
    if (descriptionText) {
      var description = document.createElement('span');
      description.className = 'pb-tabs__button-description';
      description.textContent = descriptionText;
      text.appendChild(description);
    }

    button.appendChild(text);
    return button;
  }

  function ensureButtonVisible(root, button, smooth) {
    var nav = root.querySelector('.pb-tabs__nav');
    if (!nav || !button || nav.scrollWidth <= nav.clientWidth) return;

    var navRect = nav.getBoundingClientRect();
    var buttonRect = button.getBoundingClientRect();
    var target = nav.scrollLeft;
    var edgePadding = 8;

    if (buttonRect.left < navRect.left + edgePadding) {
      target -= navRect.left + edgePadding - buttonRect.left;
    } else if (buttonRect.right > navRect.right - edgePadding) {
      target += buttonRect.right - navRect.right + edgePadding;
    } else {
      return;
    }

    nav.scrollTo({
      left: Math.max(0, target),
      behavior: smooth ? 'smooth' : 'auto'
    });
  }

  function activate(root, index, animate) {
    if (root._pbTabsTimer) window.clearTimeout(root._pbTabsTimer);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) animate = false;
    index = String(index);
    var activeButton = null;
    owned(root, '.pb-tabs__button').forEach(function(button) {
      var active = button.dataset.tabIndex === index;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
      button.tabIndex = active ? 0 : -1;
      if (active) activeButton = button;
    });
    window.requestAnimationFrame(function() {
      ensureButtonVisible(root, activeButton, animate !== false);
    });

    var panels = owned(root, '.pb-tabs__panels .pb-tab-panel');
    var current = panels.find(function(panel) { return !panel.hidden; });
    var next = panels.find(function(panel) { return panel.dataset.tabIndex === index; });
    if (!next) return;

    if (animate === false) {
      panels.forEach(function(panel) {
        panel.classList.remove('is-entering', 'is-exiting');
        panel.hidden = panel !== next;
      });
      return;
    }

    if (current === next) {
      panels.forEach(function(panel) { panel.classList.remove('is-entering', 'is-exiting'); });
      return;
    }

    if (root._pbTabsTimer) window.clearTimeout(root._pbTabsTimer);
    panels.forEach(function(panel) {
      panel.classList.remove('is-entering', 'is-exiting');
      if (panel !== current && panel !== next) panel.hidden = true;
    });

    if (!current) {
      panels.forEach(function(panel) {
        panel.hidden = panel !== next;
      });
      return;
    }

    current.classList.add('is-exiting');
    root._pbTabsTimer = window.setTimeout(function() {
      current.hidden = true;
      current.classList.remove('is-exiting');
      next.hidden = false;
      next.classList.add('is-entering');

      window.requestAnimationFrame(function() {
        window.requestAnimationFrame(function() {
          next.classList.remove('is-entering');
        });
      });
    }, 100);
  }

  function initTabs(root) {
    var nav = root.querySelector('.pb-tabs__nav');
    var panels = owned(root, '.pb-tabs__panels .pb-tab-panel');
    if (!nav || !panels.length) return;

    nav.innerHTML = '';
    panels.forEach(function(panel, panelIndex) {
      var index = panelIndex + 1;
      panel.dataset.tabIndex = String(index);
      panel.setAttribute('role', 'tabpanel');
      panel.tabIndex = 0;
      nav.appendChild(buildButton(root, panel, index));
    });

    var activePanel = panels.find(function(panel) { return panel.dataset.active === 'true'; });
    var activeIndex = activePanel ? activePanel.dataset.tabIndex : root.dataset.activeIndex || '1';
    if (!panels[Number(activeIndex) - 1]) activeIndex = '1';
    root.classList.add('is-initialized');
    activate(root, activeIndex, false);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pb-content-tabs]').forEach(initTabs);
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-pb-content-tabs] .pb-tabs__button');
    if (!button) return;
    var root = button.closest('[data-pb-content-tabs]');
    activate(root, button.dataset.tabIndex);
  });

  document.addEventListener('keydown', function(event) {
    var button = event.target.closest('.pb-tabs__button');
    if (!button || event.altKey || event.ctrlKey || event.metaKey) return;
    var root = button.closest('[data-pb-content-tabs]');
    if (!root) return;
    var nav = button.closest('[role="tablist"]');
    var vertical = nav && nav.getAttribute('aria-orientation') === 'vertical';
    var buttons = owned(root, '.pb-tabs__button');
    var index = buttons.indexOf(button);
    var direction = getComputedStyle(root).direction === 'rtl' ? -1 : 1;
    if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = buttons.length - 1;
    else if (vertical && event.key === 'ArrowDown') index++;
    else if (vertical && event.key === 'ArrowUp') index--;
    else if (!vertical && event.key === 'ArrowRight') index += direction;
    else if (!vertical && event.key === 'ArrowLeft') index -= direction;
    else return;
    event.preventDefault();
    var next = buttons[(index + buttons.length) % buttons.length];
    activate(root, next.dataset.tabIndex, false);
    next.focus({ preventScroll: true });
  });

  document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
  document.addEventListener('shopify:block:select', function(event) {
    var panel = event.target && event.target.closest ? event.target.closest('.pb-tab-panel') : null;
    if (!panel) return;
    var root = panel.closest('[data-pb-content-tabs]');
    if (root) activate(root, panel.dataset.tabIndex, false);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(document); });
  } else {
    initAll(document);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    (() => {
  const videosReady = new WeakSet();
  const dialogsReady = new WeakSet();
  const openers = new WeakMap();
  const scrollLocks = new WeakMap();

  const resetError = (video) => {
    const wrap = video.closest('.pb-video-wrap');
    wrap?.classList.remove('pb-video-wrap--error');
    const message = wrap?.querySelector('[data-pb-video-error]');
    if (message) message.hidden = true;
  };
  const showError = (video) => {
    if (!video.closest('dialog')?.open) return;
    const wrap = video.closest('.pb-video-wrap');
    wrap?.classList.add('pb-video-wrap--error');
    const message = wrap?.querySelector('[data-pb-video-error]');
    if (message) message.hidden = false;
  };
  const initialize = () => {
    document.querySelectorAll('video[data-pb-modal-video]').forEach((video) => {
      if (!videosReady.has(video)) {
        videosReady.add(video);
        video.addEventListener('error', () => showError(video));
      }
      const dialog = video.closest('dialog[data-cm]');
      if (!dialog || dialogsReady.has(dialog)) return;
      dialogsReady.add(dialog);
      dialog.addEventListener('close', () => {
        dialog.querySelectorAll('video[data-pb-modal-video]').forEach((media) => {
          media.pause();
          media.removeAttribute('src');
          media.load();
          resetError(media);
        });
        if (scrollLocks.has(dialog)) {
          const previous = scrollLocks.get(dialog);
          document.documentElement.style.overflow = previous.overflow;
          document.documentElement.style.scrollbarGutter = previous.gutter;
          window.scrollTo(0, previous.y);
          document.documentElement.style.scrollBehavior = previous.behavior;
          scrollLocks.delete(dialog);
        }
        const opener = openers.get(dialog);
        queueMicrotask(() => {
          if (opener?.isConnected && !document.querySelector('dialog[open]')) opener.focus({preventScroll: true});
        });
      });
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        dialog.close();
      });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const panel = dialog.querySelector('.cm-Panel')?.getBoundingClientRect();
        if (panel && (event.clientX < panel.left || event.clientX > panel.right || event.clientY < panel.top || event.clientY > panel.bottom)) dialog.close();
      });
    });
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const closer = target?.closest('[data-cm-close]');
    const closingDialog = closer?.closest('dialog[data-cm]');
    if (closingDialog?.querySelector('video[data-pb-modal-video]')) {
      event.preventDefault();
      event.stopPropagation();
      closingDialog.close();
      return;
    }
    const trigger = target?.closest('[data-cm-open]');
    const dialog = trigger ? document.getElementById(trigger.getAttribute('data-cm-open')) : null;
    const video = dialog?.querySelector('video[data-pb-modal-video]');
    if (!video) return;
    // Video dialogs use native focus containment. Other Page Builder dialogs
    // continue to use the theme's existing controller without any changes.
    event.preventDefault();
    event.stopPropagation();
    initialize();
    openers.set(dialog, trigger);
    if (!scrollLocks.has(dialog)) scrollLocks.set(dialog, {
      overflow: document.documentElement.style.overflow,
      gutter: document.documentElement.style.scrollbarGutter,
      behavior: document.documentElement.style.scrollBehavior,
      y: window.scrollY
    });
    document.documentElement.style.scrollBehavior = 'auto';
    document.documentElement.style.scrollbarGutter = 'stable';
    document.documentElement.style.overflow = 'hidden';
    if (!dialog.open) dialog.showModal();
    resetError(video);
    video.src = video.dataset.pbVideoSrc;
    video.load();
    const playback = video.play();
    playback?.catch(() => {
      // Browser restrictions leave the native Play control available. Actual
      // media failures reveal the direct-file fallback instead of a dead player.
      if (video.error) showError(video);
    });
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const dialog = document.querySelector('dialog[open]:has(video[data-pb-modal-video])');
    if (!dialog) return;
    event.preventDefault();
    event.stopPropagation();
    dialog.close();
  }, true);
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
